import React from 'react';

function Developer() {
	return (
		<div>
			<button
				onClick={() => {
					throw new Error('Sentry Test');
				}}
			>
				Test Error
			</button>
		</div>
	);
}

export default Developer;
